
function SiteDown() {
    return (
        <main className="relative min-h-screen overflow-hidden bg-[#050816] text-white">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(56,189,248,0.16),_transparent_26%),radial-gradient(circle_at_bottom,_rgba(37,99,235,0.22),_transparent_34%)]" />
            <div className="absolute inset-0 bg-[linear-gradient(rgba(148,163,184,0.08)_1px,transparent_1px),linear-gradient(90deg,rgba(148,163,184,0.08)_1px,transparent_1px)] bg-[size:72px_72px] opacity-20" />

            <div className="absolute left-10 top-10 h-32 w-32 rounded-full bg-cyan-400/10 blur-3xl" />
            <div className="absolute bottom-10 right-10 h-40 w-40 rounded-full bg-blue-500/10 blur-3xl" />

            <div className="relative mx-auto flex min-h-screen w-full max-w-6xl items-center px-6 py-16 md:px-10">
                <div className="grid w-full gap-8 rounded-[32px] border border-white/10 bg-slate-950/55 p-8 shadow-[0_30px_120px_rgba(2,6,23,0.8)] backdrop-blur md:grid-cols-[1.3fr_0.7fr] md:p-12">
                    <section className="flex flex-col justify-center gap-6">
                        <div className="inline-flex w-fit items-center gap-3 rounded-full border border-cyan-300/25 bg-cyan-400/10 px-4 py-2 text-sm font-semibold uppercase tracking-[0.28em] text-cyan-200">
                            <span className="relative flex h-3 w-3">
                                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-cyan-300 opacity-75" />
                                <span className="relative inline-flex h-3 w-3 rounded-full bg-cyan-200" />
                            </span>
                            Site down
                        </div>

                        <div className="space-y-4">
                            <p className="text-sm uppercase tracking-[0.35em] text-slate-300">Temporary outage</p>
                            <h1 className="max-w-3xl text-[clamp(3rem,7vw,5.8rem)] font-black uppercase leading-[0.9] text-white">
                                We are
                                <span className="block text-transparent [-webkit-text-stroke:1px_rgba(255,255,255,0.65)]">
                                    offline
                                </span>
                            </h1>
                            <p className="max-w-2xl text-base leading-8 text-slate-300 md:text-lg">
                                This website is temporarily unavailable while maintenance is in progress.
                                We are working to restore access as quickly as possible.
                            </p>
                        </div>

                        <div className="flex flex-col gap-4 pt-2 sm:flex-row">
                            <button
                                type="button"
                                onClick={() => window.location.reload()}
                                className="inline-flex items-center justify-center rounded-full bg-cyan-300 px-6 py-3 text-sm font-semibold uppercase tracking-[0.18em] text-slate-950 transition duration-300 hover:bg-cyan-200"
                            >
                                Retry connection
                            </button>
                            <div className="inline-flex items-center justify-center rounded-full border border-white/15 px-6 py-3 text-sm uppercase tracking-[0.18em] text-slate-300">
                                Please check back soon
                            </div>
                        </div>
                    </section>

                    <aside className="rounded-[28px] border border-white/10 bg-black/35 p-6 shadow-inner shadow-slate-950/50 md:p-8">
                        <div className="flex h-full flex-col justify-between gap-8">
                            <div className="space-y-4">
                                <div className="flex items-center justify-between rounded-2xl border border-white/10 bg-white/5 px-4 py-3">
                                    <span className="text-sm uppercase tracking-[0.24em] text-slate-400">System</span>
                                    <span className="rounded-full bg-cyan-300/15 px-3 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-cyan-200">
                                        Maintenance
                                    </span>
                                </div>

                                <div className="rounded-3xl border border-white/10 bg-gradient-to-br from-slate-800/70 to-slate-950/20 p-5">
                                    <div className="mb-4 flex items-center justify-between text-sm text-slate-400">
                                        <span>Status</span>
                                        <span>ETA pending</span>
                                    </div>
                                    <div className="h-3 overflow-hidden rounded-full bg-white/10">
                                        <div className="h-full w-1/2 rounded-full bg-gradient-to-r from-cyan-200 via-sky-300 to-blue-500" />
                                    </div>
                                </div>
                            </div>

                            <div className="space-y-3 rounded-3xl border border-dashed border-white/10 bg-white/5 p-5">
                                <p className="text-xs uppercase tracking-[0.28em] text-slate-400">Service notice</p>
                                <p className="text-2xl font-semibold text-white">Scheduled interruption</p>
                                <p className="text-sm leading-7 text-slate-300">
                                    Access has been paused to apply updates and stabilize the platform.
                                </p>
                            </div>
                        </div>
                    </aside>
                </div>
            </div>
        </main>
    );
}

export default SiteDown;
